import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	downloadConfiguration: {
		id: 'project-create-importer-upload-flow.review-screen-standard.download-configuration.download-configuration',
		defaultMessage:
			'<link>Download a configuration file</link> to use the same project preferences in your next import.',
		description: 'Download configuration file link with text',
	},
});
